<template>
  <div>
      <v-container fluid>
          <v-row>
              <v-col md="12" sm="12" xs="12">
                    <v-card class="mx-auto" outlined :loading="loading">
                        <v-toolbar color="teal" dark dense>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on"
                                        class="hidden-xs-only"
                                        @click="$router.go(-1)"
                                    >
                                        <v-icon>mdi-arrow-left</v-icon>
                                    </v-btn>
                                </template>
                                <span>Regresar</span>
                            </v-tooltip>
                            <v-spacer></v-spacer>
                            <v-toolbar-title>PARTIDA {{partida.numero}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-tooltip v-if="!soloLectura" bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on"
                                        class="hidden-xs-only"
                                        @click="modificarPartida=true"
                                    >
                                        <v-icon>mdi-square-edit-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>Modificar datos</span>
                            </v-tooltip>
                        </v-toolbar>
                        <v-card-text>
                            <v-container fluid>
                                <v-row dense>
                                    <v-col md="1" sm="2" xs="2">
                                        <v-text-field
                                            v-model="partida.numero"
                                            label="Recurso:"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                    <v-col md="11" sm="12">
                                        <v-text-field
                                            v-model="partida.COG.descripcion"
                                            label="Nombre de la partida:"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                    <v-col md="1" sm="2">
                                        <v-text-field
                                            v-model="partida.COG.clave"
                                            label="COG:"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                    <v-col md="1" sm="4">
                                        <v-text-field
                                            v-model="proyecto.numero"
                                            label="Proyecto:"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                    <v-col md="10" sm="12">
                                        <v-text-field
                                            v-model="proyecto.nombre"
                                            label="Nombre proyecto:"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row justify="end">
                                    <v-col md="2" sm="4">
                                        <v-text-field
                                            :value="moneda(partida.montoInicial)"
                                            label="Monto Inicial:"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                    <v-col md="2" sm="4">
                                        <v-text-field
                                            :value="moneda(partida.montoActual)"
                                            label="Monto Actual:"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                    <v-col md="2" sm="4">
                                        <v-text-field
                                            :value="moneda(partida.comprometido)"
                                            label="Comprometido:"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                    <v-col md="2" sm="4">
                                        <v-text-field
                                            :value="moneda(partida.ejercido)"
                                            label="Ejercido:"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                    <v-col md="2" sm="4">
                                        <v-text-field
                                            :value="moneda(partida.comprobado)"
                                            label="Comprobado:"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                    <v-col md="2" sm="4">
                                        <v-text-field
                                            :value="moneda(partida.disponible)"
                                            label="Disponible:"
                                            readonly
                                        ></v-text-field>
                                    </v-col>

                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
              </v-col>

              <v-col md="12" sm="12">
                    <v-card class="mx-auto" outlined>
                        <v-tabs
                            v-model="tab"
                            background-color="teal lighten-1"
                            centered
                            dark
                            >
                            <v-tabs-slider color="yellow"></v-tabs-slider>

                            <v-tab href="#tab-1">Gastos</v-tab>
                            <v-tab href="#tab-2">Compensaciones</v-tab>
                        </v-tabs>

                        <v-tabs-items v-model="tab">
                            <v-tab-item value="tab-1">
                                <gastos-partida-component 
                                    :idPartida="partida._id"
                                    :gastos="partida.gastos"
                                    @gastoAgregado="cargarPartida()"
                                    @gastoModificado="cargarPartida()"
                                    @gastoEliminado="cargarPartida()"
                                />
                            </v-tab-item>
                            <v-tab-item value="tab-2">
                                <transferencias-partida-component 
                                    :idPartida="partida._id"
                                    :transferencias="partida.transferencias"
                                    @transferenciaAgregada="cargarPartida()"
                                    @transferenciaModificada="cargarPartida()"
                                    @transferenciaEliminada="cargarPartida()"
                                />
                            </v-tab-item>
                        </v-tabs-items>
                    </v-card>
              </v-col>
          </v-row>
      </v-container>

      <modificar-partida-component 
        v-if="modificarPartida"
        :mostrar="modificarPartida"
        :partida="partida"
        @cancelar="modificarPartida=false"
        @partidaModificada="partidaModificada"
      />

  </div>
</template>
<script>

const numeral = require('numeral');
import axios from 'axios';
import { mapGetters} from 'vuex'
import moment from 'moment';
moment.locale('es');

import ModificarPartidaComponent from '../components/partidas/modificarPartida'
import GastosPartidaComponent from '../components/partidas/gastosPartida'
import TransferenciasPartidaComponent from '../components/partidas/transferenciasPartida'

export default {
    components:{ 
        ModificarPartidaComponent, 
        GastosPartidaComponent, 
        TransferenciasPartidaComponent 
    },
    computed: {
        ...mapGetters([
            "httpURL",
            "sessionToken",
            "soloLectura"
        ])
    },
    watch:{
        '$route.params.id'(nuevo,anterior){
            this.cargarPartida();
        }
    },
    data () {
        return {
            loading: false,
            search: null,
            tab: null,
            modificarPartida: false,
            partida: {
                COG:{},
                gastos:[],
                transferencias: []
            },
            proyecto: {},
        }
    },
    created(){
        this.cargarPartida();
    },
    methods:{
        fechaTxt(fecha){
            return moment(fecha,'YYYY-MM-DD').format('DD/MM/YYYY');
        },
        moneda(numero){
            if(isNaN(numero)) return '';
            const options2 = { style: "currency", currency: "USD" };
            const numberFormat2 = new Intl.NumberFormat("en-US", options2);
            if(numero==0) return (numberFormat2.format(0));
            return (numberFormat2.format(numero));
        },
        calcularSubtotal(){
            let sumatoria = 0;
            this.objetivo.partidas.forEach(partida => {
                sumatoria += partida.montoActual;
            });
            this.subtotal = sumatoria;
        },
        ordenarPartidas(){
            this.objetivo.partidas.sort((a,b)=>(a.numero > b.numero) ? 1 : ((b.numero > a.numero) ? -1 : 0));
        },
        partidaModificada(){
            this.cargarPartida();
            this.modificarPartida = false;
        },
        cargarPartida(){
            this.loading = true;
            axios.get(this.httpURL+'/partida/'+this.$route.params.id,{headers:{token:this.sessionToken}})
                .then(res => {
                    // console.log(res.data);
                    if( res.data.ok){
                        this.partida = res.data.partida;
                        this.proyecto = res.data.proyecto;
                        this.partida.gastos.sort((a,b)=>(a.fecha > b.fecha) ? 1 : ((b.fecha > a.fecha) ? -1 : 0));
                        this.partida.transferencias.sort((a,b)=>(a.fecha > b.fecha) ? 1 : ((b.fecha > a.fecha) ? -1 : 0));
                    }else
                        this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                    this.loading = false;
                })
                .catch(error => {
                    // console.log('Error: '+error);
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
                    this.loading = false;
                });
        }
    }
}
</script>